import formatDate from "@/helpers/formatDate";

export function jsonToFormData(
  json: object,
  formData = new FormData(),
  parentKey = ""
) {
  Object.keys(json).forEach(key => {
    let value = json[key as keyof object] as any;
    const formKey = parentKey ? `${parentKey}[${key}]` : key;
    if (
      value instanceof Object &&
      !Array.isArray(value) &&
      !(value instanceof File) &&
      !(value instanceof Date)
    ) {
      jsonToFormData(value, formData, formKey);
    } else if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (item instanceof Object && !(item instanceof File)) {
          jsonToFormData(item, formData, `${formKey}[${index}]`);
        } else {
          formData.append(`${formKey}[${index}]`, item);
        }
      });
    } else {
      if (value instanceof Date) {
        value = formatDate(value);
      }
      formData.append(formKey, value || "");
    }
  });

  return formData;
}
